import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@zapier/zinnia-icons";
import atoms from "../../../styles/atoms.module.scss.js";
import { useDetails } from "../../../utils/useDetails.js";
import { Avatar } from "../Avatar/Avatar.js";
import { useHeaderContext } from "../Header.js";
import styles from "./AccountMenu.module.scss.js";
function AccountMenu(props) {
  const context = useHeaderContext();
  const { ref, isOpen, handleSummaryClick } = useDetails({
    onOpen: () => {
      context.emitUserInteractionEvent({
        event_action: "open",
        interaction_name: "header_account_menu_open"
      });
    },
    onClose: () => {
      context.emitUserInteractionEvent({
        event_action: "close",
        interaction_name: "header_account_menu_close"
      });
    }
  });
  const currentAccount = props.accounts.find(
    (account) => account.id == props.session.current_account_id
  );
  const isCurrentAccount = (id) => {
    return (currentAccount == null ? void 0 : currentAccount.id) ? id === currentAccount.id : false;
  };
  return /* @__PURE__ */ jsxs(
    "details",
    {
      className: atoms.relative,
      ref,
      open: isOpen,
      "data-testid": "account-menu",
      children: [
        /* @__PURE__ */ jsx(
          "summary",
          {
            className: styles.summary,
            "aria-label": "Account menu",
            "aria-haspopup": "menu",
            "data-testid": "account-menu-summary",
            onClick: handleSummaryClick,
            children: /* @__PURE__ */ jsx(
              Avatar,
              {
                name: (currentAccount == null ? void 0 : currentAccount.name) ?? "",
                url: currentAccount == null ? void 0 : currentAccount.avatar,
                selected: isOpen
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: styles.content, role: "menu", children: [
          props.session.email && /* @__PURE__ */ jsx("div", { className: styles.email, children: props.session.email }),
          props.accounts.length > 0 && /* @__PURE__ */ jsx("ul", { className: styles.list, children: props.accounts.map((account) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
            "a",
            {
              className: `${styles.link} ${isCurrentAccount(account.id) ? styles.selected : ""}`,
              href: context.resolveURL(
                `/switch-account?account=${account.id}&next=${window.location.href}`
              ),
              role: "menuitem",
              onClick: (e) => {
                context.emitLinkClickEvent(e, {
                  interaction_name: "header_account_menu_switch_account_click"
                });
              },
              children: [
                /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    name: account.name,
                    url: account.avatar,
                    selected: isCurrentAccount(account.id)
                  }
                ),
                /* @__PURE__ */ jsxs("span", { className: styles.accountTextContainer, children: [
                  /* @__PURE__ */ jsx("span", { children: account.name }),
                  /* @__PURE__ */ jsx("span", { children: account.hasTeams ? "Organization" : "Individual" })
                ] }),
                isCurrentAccount(account.id) && /* @__PURE__ */ jsx(Icon, { isBlock: true, name: "formCheck", size: 24 })
              ]
            }
          ) }, account.id)) }),
          /* @__PURE__ */ jsxs("ul", { className: styles.list, children: [
            /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
              "a",
              {
                className: styles.link,
                href: context.resolveURL("/app/settings/profile"),
                role: "menuitem",
                onClick: (e) => {
                  context.emitLinkClickEvent(e, {
                    interaction_name: "header_account_menu_link_click"
                  });
                },
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "navCog", size: 18 }),
                  /* @__PURE__ */ jsx("span", { children: "Settings" })
                ]
              }
            ) }),
            /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
              "a",
              {
                className: styles.link,
                href: context.resolveURL("/logout"),
                role: "menuitem",
                onClick: (e) => {
                  context.emitLinkClickEvent(e, {
                    interaction_name: "header_account_menu_link_click"
                  });
                },
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "arrowExit", size: 18 }),
                  /* @__PURE__ */ jsx("span", { children: "Log out" })
                ]
              }
            ) })
          ] })
        ] })
      ]
    }
  );
}
export {
  AccountMenu
};
